import AuditLog from '@/utilities/AuditLog'
import {AUDIT_LOG_ENABLED} from './config'

const auditLog = new AuditLog(AUDIT_LOG_ENABLED)

export default auditLog
